import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { Toaster } from 'sonner'
import { CheckCircle2, XCircle, Info, AlertTriangle } from 'lucide-react'
import './index.css'
import Routes from './routes'
import rootStore from './stores/RootStore'
import { RootStoreProvider } from './stores/RootStoreContext'

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <RootStoreProvider value={rootStore}>
      <Routes />
      <Toaster
        position="top-right"
        offset={16}
        gap={8}
        icons={{
          success: <CheckCircle2 size={18} strokeWidth={2.2} />,
          error: <XCircle size={18} strokeWidth={2.2} />,
          info: <Info size={18} strokeWidth={2.2} />,
          warning: <AlertTriangle size={18} strokeWidth={2.2} />,
        }}
        toastOptions={{
          style: {
            fontFamily: "'Sora', sans-serif",
            background: 'var(--dash-surface)',
            border: '1px solid var(--dash-border-strong)',
            color: 'var(--dash-text)',
            borderRadius: 14,
            boxShadow: '0 8px 32px rgba(0,0,0,0.28), 0 0 0 1px var(--dash-border)',
            backdropFilter: 'blur(16px) saturate(1.4)',
            padding: '14px 16px',
            gap: 12,
          },
        }}
      />
    </RootStoreProvider>
  </StrictMode>
)
